<div [id]="id" class="c-form-element-toggle" [ngClass]="{ 'is-disabled': !isEnable }">
  <div class="c-form-element-toggle__wrap">
    <input
      type="checkbox"
      id="switch_{{ id }}"
      name="switch_name_{{ id }}"
      class="c-form-element-toggle__input"
      (change)="changeSwitchEvent($event)"
      [(ngModel)]="checked"
      [checked]="checked ? 'checked' : ''"
      [disabled]="!isEnable"
    />
    <label for="switch_{{ id }}" class="c-form-element-toggle__label">
      <span class="c-form-element-toggle__toggle"></span>
      <span class="c-form-element-toggle__label-text u-visually-hidden">{{ altMessage }}</span>
    </label>
    <ng-container *ngIf="text.length !== 0">
      <div class="c-form-element-toggle__text" aria-hidden="true">{{ text }}</div>
    </ng-container>
  </div>
</div>
